import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import { fontSize } from 'suneditor/src/plugins';
import {useSelector} from "../../../Redux";
import { GetStateFromData } from '../../CustomHooks/CustomHooks';


const SearchControl = (props) => {

    const useStyles = makeStyles((theme) => ({
        root: {
            // padding: '2px 4px',
            display: 'flex',
            alignItems: 'center',
            // width: 400,
            marginLeft: props.searchCollapsed ? "15px": (props.collapsed===false) ? '21px' : props?.openedFromLeftNav ? '8px' : 'auto',
            marginRight: props.searchCollapsed ? "8px":(props.collapsed===false) ? '21px' : props?.openedFromLeftNav ? '8px' : 'auto',
            marginTop:'13px',
            marginBottom:'1px',
            border: (props.collapsed===false)? '1px solid #C4C4C4':'0px solid transparent',
            borderRadius:'2px',
            background: '#FFFFFF 0% 0% no-repeat padding-box',
            height:'28px',
            // -webkit-transition: width 1s ease-in-out;
            // -moz-transition: width 1s ease-in-out;
            // -o-transition: 'width 1s ease-in-out',
            transition: 'width 0.5s ease-in-out',
            width: props.collapsed? props.collapsedWidth:props.width,
            
        },
        input: {
            marginLeft:"0px !important",
            flex: 1,
            paddingTop:0,
            paddingBottom:0,
            textAlign: 'left',
            fontSize:'12px',
            lineHeight: '17px',
            fontFamily: 'Open Sans',
            letterSpacing: '0px',
            color: '#606060',
            opacity: 1,
        },
        iconButton: {
            padding: 10,
            height: 12,
        },
        iconButtonCollapsed:{
            position: "absolute !important",
            left:(props)=>props.translationStyles1?"23px":null,
            right:(props)=>props.translationStyles1?"unset !important": "12px !important",
            marginRight:"unset !important",
        },
        divider: {
            height: 28,
            margin: 'auto',
        },
        parentDiv: {
            boxShadow: props.collapsed || props.searchCollapsed?'':'0px 3px 6px #0000000D',
        }
    }));
    const translationStyles1=window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";  
    const classes = useStyles({translationStyles1});

    const [searchValue, setSearchValue] = useState("")

    useEffect(() => {
        setSearchValue(props?.search)
    }, [props.selectedMenuItemNameState])

    useEffect(() => {
        props?.setSearch(searchValue)
    }, [searchValue])

   
    const handleChange = (e) => {
        setSearchValue(e.target.value)
    }

    const handleBlur = (e) => {
        setSearchValue(e.target.value)
    }

    

    return (
        <div className={`${classes.parentDiv} search_LeftNav`}>
            <Paper 
                // component="form" 
                className={classes.root} 
                elevation={0} id="leftNavigation_search"
            >
            {/* <div className={classes.root} > */}
            <label aria-label={"input controls search appform"} style={{maxWidth: "0", overflow: "hidden"}} htmlFor='input_controls_search_appform'>
                hidden
            </label>

                <InputBase
                    inputProps={{
                        "aria-label":"Controls Search"
                      }}
                    aria-label={"Controls Search"} 
                    id="input_controls_search_appform"
                    name="input_controls_search_appform"
                    className={`${classes.input} search_LeftNav`}
                    placeholder={(props.collapsed===false)?'Search':""}
                    inputRef={props.textRef}
                    // inputProps={{ 'aria-label': 'search google maps' }}
                    value={props?.search}
                    onChange={(e)=> handleChange(e)}
                    onBlur={(e) => handleBlur(e)}
                />


                
                {/* <input 
                    type="text"  
                    onChange={e=>{e.preventDefault(); props.setSearch(e.target.value);}}
                /> */}
                <IconButton 
                    onClick={(e) => props.on_click(e, props?.anchor, "on", props?.selectedMenuItemNameState || "Common Fields")}
                    onKeyDown={(e) => props.on_keyDown(e, props?.anchor, "on", props?.selectedMenuItemNameState || "Common Fields")}
                    className={props.collapsed ? classes.iconButtonCollapsed : classes.iconButton}
                    aria-label="search"
                    title={`Search ${props?.selectedMenuItemNameState || "Common Fields"}`}
                >
                    <SearchIcon />
                </IconButton>
                {/* </div> */}
            </Paper>
        </div>
    )
}

export default SearchControl
